<script>
export default {
  name: 'VisTableComponents',
  props: {
    componentId: {
      type: String,
      default: ''
    },
    options: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      visTable: null
    }
  },
  watch: {
    'options.data': {
      handler(val) {
        // this.initVisTable()
        this.visTable.setRecords(val)
      },
      deep: true
    }
  },
  mounted() {
    window.addEventListener('resize', () => {
      this.visTable.renderWithRecreateCells()
    })
    this.initVisTable()
  },
  beforeDestroy() {
    if (!this.visTable) {
      return
    }
    /* 释放图表实例 */
    this.visTable.release()
    this.visTable = null
    window.removeEventListener('resize', () => {
      this.visTable = null
    })
  },
  methods: {
    release() {
      this.visTable.release()
    },
    render() {
      this.visTable.release()
      this.initVisTable()
    },
    flatten(arr) {
      return arr.reduce((prev, next) => {
        return prev.concat(Array.isArray(next.columns) ? this.flatten(next.columns) : next)
      }, [])
    },
    initVisTable() {
      // 注册事件必须在VTable实例化之前
      const theme = {
        defaultStyle: {
          borderLineWidth: 1,
          textAlign: 'center',
          borderColor: '#ebeef5',
          ...this.options.defaultStyle
        },
        headerStyle: {
          bgColor: '#F7F7F7',
          color: '#333333',
          fontSize: 14,
          lineHeight: 25,
          ...this.options.headerStyle
        },
        bodyStyle: {
          ...this.options.bodyStyle
        }
      }
      const option = {
        container: document.getElementById(this.componentId),
        records: this.options.data,
        ...this.options,
        // allowFrozenColCount: 1, // 表示固定前几列 数字多少则代表固定多少列
        heightMode: 'autoHeight',
        // autoFillHeight: true,
        editCellTrigger: 'click',
        theme: this.options.theme ? { ...theme, ...this.options.theme } : theme,
        rightFrozenColCount: this.options.rightFrozenColCount
      }
      const VTable = this.$VTable
      const visTable = new VTable.ListTable(option)
      visTable.on('change_cell_value', arg => {
        this.$emit('editChange', arg)
      })
      visTable.on('click_cell', arg => {
        this.$emit('iconClick', arg)
      })
      this.visTable = visTable
    }
  },
  render() {
    return (
      <div
        ref={this.componentId}
        id={this.componentId}
        class="visTableContanier"
      ></div>
    )
  }
}
</script>
<style lang="less" scoped>
.visTableContanier {
  width: 100%;
  height: 100%;
  /deep/ * {
    outline: none;
  }
}
</style>
